import React, { useState } from 'react';

const VoiceOrder = () => {
  const [orderText, setOrderText] = useState('');
  const [isListening, setIsListening] = useState(false);
  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    margin: 0,
  };
console.log("orderText",orderText)
  const contentStyle = {
    padding: '2rem',
    borderRadius: '12px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    backgroundColor: '#fff',
    textAlign: 'center',
  };
  // Initialize speech recognition (Web Speech API)
  const recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();

  recognition.lang = 'en-US';
  recognition.continuous = true;
  recognition.interimResults = true;

  const startListening = () => {
    recognition.start();
    setIsListening(true);
  };

  const stopListening = () => {
    recognition.stop();
    setIsListening(false);
  };

  recognition.onresult = (event) => {
    const currentResult = event.results[event.results.length - 1];
    const transcript = currentResult[0].transcript;
    setOrderText(transcript);
  };

  const submitOrder = async () => {
    if (orderText) {
      try {
        // Send order text to the backend
        const response = await fetch('/api/orders', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ order: orderText }),
        });
        const data = await response.json();
        alert('Order placed: ' + data.message);
      } catch (error) {
        alert('Failed to place order.');
      }
    }
  };

  return (
    <div style={containerStyle}>
      <div style={contentStyle}>
      <h2>Place Order via Voice Command</h2>
      <button onClick={isListening ? stopListening : startListening}>
        {isListening ? 'Stop Listening' : 'Start Listening'}
      </button>
      <p>Order: {orderText}</p>
      <button onClick={submitOrder} disabled={!orderText}>Submit Order</button>
      </div>
      
    </div>
  );
};

export default VoiceOrder;
